import {NOT_FOUND, Payload} from 'redux-first-router';
import {fetch, stub} from 'App/services';
import {ThunkDispatch} from "redux-thunk";
import {AnyAction} from "redux";
import {ApplicationState} from "App/store";
import {ActionType, ContactType, Language} from "App/constants";
import {CurrentConfiguration} from "App/services/api";
import {buildConfiguration} from "App/basket";
import {default as i18n} from "i18next";
import {selectedLang} from "App/helper";

export interface CategoryPayload extends Payload {
    catId: number;
}

export interface SubCategoryPayload extends CategoryPayload {
    subId: number;
}

export interface ConfigurationPayload extends SubCategoryPayload {
    prodId: number;
}

export interface SpecialOfferPayload extends Payload {
    sogId: number;
}

export interface OrderPayload extends Payload {
    type: ContactType;
}

async function fetchDataByRoute(dispatch: ThunkDispatch<any,null,AnyAction>, getState: () => ApplicationState, catId:number|undefined, subId:number|undefined, prodId:number|undefined) {
    var state: ApplicationState = getState();
    if (!state.data.categories.length) {
        await fetch(dispatch, ActionType.FETCH_MAINCATEGORIES, null, stub.retrieveAllUsedMainCategories())
    }
    if (catId&&!state.data.subcategories) {
        await fetch(dispatch, ActionType.FETCH_PRODUCTFAMILYICONS, catId, stub.retrievePfiByUsedMainCategory(catId))
    }
    if (catId&&subId&&!state.data.products) {
        await fetch(dispatch, ActionType.FETCH_PRODUCTSBYFAMILYICONS, subId, stub.retrieveProductsByProductFamilyIcon(subId))
    }
    if (catId&&subId&&prodId) {
        if (!state.data.configuration) {
            await fetch(dispatch, ActionType.FETCH_CONFIGURATORPRODUCT, prodId, stub.retrieveConfiguratorProduct(prodId))
        } else {
            await validateOrder(dispatch, getState, undefined);
        }
    }
}

export async function validateOrder(dispatch: ThunkDispatch<any,null,AnyAction>, getState: () => ApplicationState, type: ContactType | undefined) {
    if (!getState().basket.syncState.pending) {
        do {
            var language: Language = selectedLang(i18n);
            var configuration: CurrentConfiguration | undefined = buildConfiguration(getState().basket, getState().contactData, language, getState().currency, type);
            await fetch(dispatch, ActionType.CHECK_CONFIGURATION, {language: language, currency: getState().currency}, stub.submitConfiguration(configuration));
        } while (getState().basket.syncState.pending && !getState().basket.syncState.failed)
    }
}

export const routePaths = {
    [ActionType.PAGE_MAIN]: {
        path: '/',
        thunk: (dispatch: ThunkDispatch<any,null,AnyAction>, getState: () => ApplicationState) => {
            fetchDataByRoute(dispatch, getState, undefined, undefined, undefined);
            fetch(dispatch, ActionType.FETCH_SPECIALOFFERSCOMPACTOVERVIEW, undefined, stub.specialOffersCompactOverview());
        }
    },
    [ActionType.PAGE_CATEGORY]: {
        path: '/:catId/categories',
        thunk: (dispatch: ThunkDispatch<any,null,AnyAction>, getState: () => ApplicationState) => {
            // @ts-ignore
            const payload : CategoryPayload  = <CategoryPayload> getState().location.payload;
            fetchDataByRoute(dispatch, getState, payload.catId, undefined, undefined);
        }
    },
    [ActionType.PAGE_SUBCATEGORY]: {
        path: '/:catId/categories/:subId/products',
        thunk: (dispatch: ThunkDispatch<any,null,AnyAction>, getState: () => ApplicationState) => {
            // @ts-ignore
            const payload : SubCategoryPayload  = <SubCategoryPayload> getState().location.payload;
            fetchDataByRoute(dispatch, getState, payload.catId, payload.subId, undefined);
        }
    },
    [ActionType.PAGE_SPECIALOFFER]: {
        path: '/:sogId/specialoffers',
        thunk: async (dispatch: ThunkDispatch<any,null,AnyAction>, getState: () => ApplicationState) => {
            if (!getState().data.specialoffers) {
                // @ts-ignore
                const payload: SpecialOfferPayload = <SpecialOfferPayload>getState().location.payload;
                await fetch(dispatch, ActionType.FETCH_SPECIALOFFERSCOMPACTOVERVIEW, undefined, stub.specialOffersCompactOverview());
            }
        }
    },
    [ActionType.PAGE_CONFIGURATION]: {
        path: '/:catId/categories/:subId/products/:prodId/configuration',
        thunk: (dispatch: ThunkDispatch<any,null,AnyAction>, getState: () => ApplicationState) => {
            // @ts-ignore
            const payload : ConfigurationPayload  = <ConfigurationPayload> getState().location.payload;
            fetchDataByRoute(dispatch, getState, payload.catId, payload.subId, payload.prodId);
        }
    },
    [ActionType.PAGE_CONTRACT]: {
        path: '/contract',
        thunk: (dispatch: ThunkDispatch<any,null,AnyAction>, getState: () => ApplicationState) => {
            // @ts-ignore
            const payload : OrderPayload  = <OrderPayload> getState().location.payload;
            payload&&payload.type?validateOrder(dispatch, getState, payload.type):dispatch(selectMainPageAction());
        }
    },
    [ActionType.PAGE_OFFER]: {
        path: '/offer',
        thunk: (dispatch: ThunkDispatch<any,null,AnyAction>, getState: () => ApplicationState) => {
            // @ts-ignore
            const payload : OrderPayload  = <OrderPayload> getState().location.payload;
            payload&&payload.type?validateOrder(dispatch, getState, payload.type):dispatch(selectMainPageAction());
        }
    },
    [NOT_FOUND]: 'NotFound'
};

export function selectMainPageAction(): any {
    return {
        type: ActionType.PAGE_MAIN,
    }
}

export function selectCategoryPageAction(catId:number): any {
    return { type: ActionType.PAGE_CATEGORY, payload: { catId } }
}

export function selectSubCategoryPageAction(catId: number, subId:number): any {
    return { type: ActionType.PAGE_SUBCATEGORY, payload: { catId, subId } }
}

export function selectSpecialOfferPageAction(sogId: number): any {
    return { type: ActionType.PAGE_SPECIALOFFER, payload: { sogId } }
}

export function selectConfigurePageAction(catId: number, subId:number, prodId: number): any {
    return { type: ActionType.PAGE_CONFIGURATION, payload: { catId, subId, prodId } }
}

export function selectContractPageAction(): any {
    return { type: ActionType.PAGE_CONTRACT, payload: { type: ContactType.CONTRACT } }
}

export function selectOfferPageAction(): any {
    return { type: ActionType.PAGE_OFFER, payload: { type: ContactType.OFFER } }
}



// WEBPACK FOOTER //
// ./src/routes/index.ts